import { mockComponent } from 'bloko/common/setupMockComponents';

export default mockComponent('TreeSelectorDummy');
